var ALIAS_TOKEN = "@:";
var LEFT_TOKEN = "{{";
var RIGHT_TOKEN = "}}";
var PIPE_TOKEN = "|";
var TOKEN_LENGTH = LEFT_TOKEN.length === RIGHT_TOKEN.length && LEFT_TOKEN.length; // --

var INTERPOLATION_START_TOKEN = "{{";
var INTERPOLATION_END_TOKEN = "}}";

function hasAlias(input) {
  return input.indexOf(ALIAS_TOKEN) === 0;
}

function hasInterpolation(input) {
  return input.indexOf(INTERPOLATION_START_TOKEN) > -1;
}

function hasProcessor(input) {
  return input.indexOf(PIPE_TOKEN) > -1;
}

function createAlias(input) {
  var body = input.slice(ALIAS_TOKEN.length);
  return {
    type: "alias",
    body
  };
}

function createString(input) {
  return {
    type: "string",
    body: input
  };
}

function createTranslation(input) {
  return {
    type: "translation",
    body: input
  };
}

function createVariable(input) {
  if (hasProcessor(input)) {
    var [body, processor] = input.split(PIPE_TOKEN);
    return {
      type: "variable",
      body,
      processor
    };
  }

  return {
    type: "variable",
    body: input
  };
}

function parseBody(input) {
  if (input.length === 0) {
    return [];
  }

  if (!hasInterpolation(input)) {
    return [createString(input)];
  }

  var outerStart = input.indexOf(INTERPOLATION_START_TOKEN);
  var innerEnd = input.indexOf(INTERPOLATION_END_TOKEN);

  if (outerStart === -1 || innerEnd === -1) {
    throw new SyntaxError("One of closing tokens '".concat(RIGHT_TOKEN, "' not found"));
  }

  var innerStart = outerStart + TOKEN_LENGTH;
  var outerEnd = innerEnd + TOKEN_LENGTH;

  if (outerStart > 0) {
    var _chunk = input.slice(0, outerStart);

    var _token = createString(_chunk);

    var _nextInput = input.slice(outerStart);

    return [_token, ...parseBody(_nextInput)];
  }

  var chunk = input.slice(innerStart, innerEnd).replace(/\s+/g, "");
  var token = createVariable(chunk);
  var nextInput = input.slice(outerEnd);
  return [token, ...parseBody(nextInput)];
}

function parse(input) {
  if (input == null) {
    return null;
  }

  if (hasAlias(input)) {
    return createAlias(input);
  }

  if (!hasInterpolation(input)) {
    return createTranslation([createString(input)]);
  }

  return createTranslation(parseBody(input));
}

export { parse };
